import React from 'react';
import { store } from '../Store';

import './CloseButton.css';
import close from '../assets/images/close.svg';

export function CloseButton(props) {
  return (
    <div 
    className='close-button' 
    onClick={() => { 
      store.setHotspotVisited(store.currentHotspotId);
      store.setCurrentHotspot(null);
      store.setHotspotPanelVisible(false);
      store.setPlayAnimation(false);
    }}
    >
      <img src={close} alt="Exit" />
    </div>
  )
}